import { render, staticRenderFns } from "./BreakdownTypeBasicForm.vue?vue&type=template&id=ebcbb182"
import script from "./BreakdownTypeBasicForm.vue?vue&type=script&lang=js"
export * from "./BreakdownTypeBasicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports